// Avatar personalizado (editor do Perfil, docs/avatares.md).
// As opções possíveis vêm de avatarEditorOpcoes.json, cópia exata de
// backend/src/avatares/editor.json (a lista branca que o backend confere; um
// teste do backend garante que as duas são iguais).
import EDITOR from './avatarEditorOpcoes.json';
import { resolveApiBaseURL } from '../services/api';

export { EDITOR };

export const CHAVES = ['expressao', 'pele', 'cabelo', 'corCabelo', 'oculos', 'barba', 'roupa', 'fundo'];

const cores = (lista) => lista.map((c) => c.cor);
const PERMITIDOS = {
  expressao: EDITOR.expressoes,
  pele: cores(EDITOR.peles),
  cabelo: EDITOR.cabelos,
  corCabelo: cores(EDITOR.coresCabelo),
  oculos: [null, ...EDITOR.oculos],
  barba: [null, ...EDITOR.barbas],
  roupa: cores(EDITOR.roupas),
  fundo: cores(EDITOR.fundos),
};

// Completa/corrige: o que não estiver na lista volta ao padrão.
export const normalizar = (opcoes) => Object.fromEntries(CHAVES.map((k) => {
  const v = opcoes ? opcoes[k] : undefined;
  return [k, PERMITIDOS[k].includes(v) ? v : EDITOR.padrao[k]];
}));

// Opções DiceBear de um avatar do catálogo -> escolhas do editor.
export const doCatalogo = (o = {}) => normalizar({
  expressao: o.expressionVariant,
  pele: o.skinColor,
  cabelo: o.headVariant,
  corCabelo: o.headContrastColor,
  oculos: o.accessoriesProbability ? o.accessoriesVariant : null,
  barba: o.facialHairProbability ? o.facialHairVariant : null,
  roupa: o.clothingColor,
  fundo: o.backgroundColor,
});

// Mesmo mapeamento do backend (services/avatarPersonalizadoService.paraDicebear).
export const paraDicebear = (o) => ({
  seed: 'exxer',
  headVariant: o.cabelo,
  expressionVariant: o.expressao,
  facialHairProbability: o.barba ? 100 : 0,
  ...(o.barba ? { facialHairVariant: o.barba } : {}),
  accessoriesProbability: o.oculos ? 100 : 0,
  ...(o.oculos ? { accessoriesVariant: o.oculos } : {}),
  maskProbability: 0,
  skinColor: o.pele,
  clothingColor: o.roupa,
  headContrastColor: o.corCabelo,
  backgroundColor: o.fundo,
});

const sortear = (lista, rnd) => lista[Math.floor(rnd() * lista.length)];

// Óculos e barba em ~1/3 das vezes, para o "Aleatório" não sair sempre enfeitado.
export const aleatorio = (rnd = Math.random) => ({
  expressao: sortear(PERMITIDOS.expressao, rnd),
  pele: sortear(PERMITIDOS.pele, rnd),
  cabelo: sortear(PERMITIDOS.cabelo, rnd),
  corCabelo: sortear(PERMITIDOS.corCabelo, rnd),
  oculos: rnd() < 0.33 ? sortear(EDITOR.oculos, rnd) : null,
  barba: rnd() < 0.33 ? sortear(EDITOR.barbas, rnd) : null,
  roupa: sortear(PERMITIDOS.roupa, rnd),
  fundo: sortear(PERMITIDOS.fundo, rnd),
});

// Sobe quando o desenho muda sem mudar as escolhas: o hash fica igual e a imagem
// tem cache imutável, então é isto que faz o navegador buscar a versão nova.
const VERSAO_DO_DESENHO = 2;

// URL da imagem gerada pelo backend. O hash muda a cada troca (cache imutável).
export const urlDoAvatarPersonalizado = (usuarioId, hash) => {
  if (!usuarioId || !/^[0-9a-f]{16}$/.test(String(hash || ''))) return null;
  return `${resolveApiBaseURL().replace(/\/$/, '')}/avatars/personalizado/${Number(usuarioId)}/${hash}.svg?d=${VERSAO_DO_DESENHO}`;
};
